


































































































































































































import { Vue, Prop, Component } from "vue-property-decorator"
import { WebinarInfo } from "@/models/WebinarInfo"
import { VideoInfo } from "@/models/VideoInfo"
import VideoPlayer from "../shared/VideoPlayer.vue"
import InfoTab from "../shared/InfoTab.vue"
import { formatDate } from "@/services/DurationFormatter"
import "@/assets/playlist.scss"
import { EventBus } from "@/event-bus"
import getParams from "@/services/getParams"
import IframeVideoPlayer from "../shared/IframeVideoPlayer.vue"
@Component({
  components: {
    VideoPlayer,
    InfoTab,
    IframeVideoPlayer
  }
})
export default class PlaylistLayout extends Vue {
  @Prop() public webinarInfo!: WebinarInfo
  errorPosterHeight = 0
  isgated =
    this.webinarInfo.moments.length > 0
      ? this.webinarInfo.moments[0].is_gated
      : this.webinarInfo.is_gated
  isPannelVisible = false
  currentVideo =
    this.webinarInfo.moments.length > 0
      ? this.webinarInfo.moments[0].video_urls
      : this.webinarInfo.video_urls
  videoPlayerKey = 0
  panelHeight = 0
  videowidth = 1024
  mid =
    this.webinarInfo.moments.length > 0 ? this.webinarInfo.moments[0].id : -1
  currentDuration =
    this.webinarInfo.moments.length > 0
      ? this.webinarInfo.moments[0].duration
      : this.webinarInfo.duration
  momentId = ""
  currentSubtitleUrls =
    this.webinarInfo.moments.length > 0
      ? this.webinarInfo.moments[0].subtitle_urls
        ? this.webinarInfo.moments[0].subtitle_urls
        : {}
      : this.webinarInfo.subtitle_urls
      ? this.webinarInfo.subtitle_urls
      : {}
  currentSubtitles =
    this.webinarInfo.moments.length > 0
      ? this.webinarInfo.moments[0].subtitles
        ? this.webinarInfo.moments[0].subtitles
        : []
      : this.webinarInfo.subtitles
      ? this.webinarInfo.subtitles
      : []
  public dateformatter(date: string) {
    return formatDate(date)
  }
  public created() {
    EventBus.$on("highlight-moment", this.loadmoment)
  }
  public mounted() {
    this.videowidth = (this.$refs.videocontainer as HTMLElement).clientWidth
    this.panelHeight = (this.$refs.curvideo as HTMLElement).clientHeight
    setTimeout(this.init, 200)
    var id = setTimeout(this.handleResize, 500)
    setTimeout(this.handleResize, 1000)
    setTimeout(this.handleResize, 2000)
    setTimeout(this.handleResize, 3000)
    this.isPannelVisible = true
    this.errorPosterHeight = this.$refs.video_error_poster
      ? (Array.from(this.$refs.video_error_poster as any)[0] as HTMLElement)
          .clientWidth * 0.56
      : 0
    setTimeout(this.focus, 100)
  }
  loadmoment() {
    if (this.momentId != "") {
      this.webinarInfo.moments.forEach(moment => {
        if (moment.id == this.momentId) {
          this.currentVideo = moment.video_urls
          this.currentDuration = moment.duration
          this.isPannelVisible = false
          this.isgated = moment.is_gated
          this.currentSubtitleUrls = moment.subtitle_urls
          this.currentSubtitles = moment.subtitles
          this.videoPlayerKey += 1
        }
      })
    }
  }
  focus() {
    var url = window.location.search
    if (url.length == 0) return
    this.momentId = getParams(url)
    var momentdiv = document.getElementById(
      "moment-" + this.momentId
    ) as HTMLElement
    if (momentdiv) {
      ;(document.getElementById("pl--c") as HTMLElement).scrollIntoView(true)
      EventBus.$emit("highlight-moment")
    }
  }
  public beforeMount() {
    window.addEventListener("resize", this.handleResize)
  }
  public beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  }
  public handleResize() {
    this.videowidth = (this.$refs.videocontainer as HTMLElement).clientWidth
    EventBus.$emit("carouselSetupCompleted")
    this.panelHeight = (this.$refs.curvideo as HTMLElement).clientHeight
    this.errorPosterHeight = this.$refs.video_error_poster
      ? (Array.from(this.$refs.video_error_poster as any)[0] as HTMLElement)
          .clientWidth * 0.56
      : this.$refs.video_error_poster_webinar
      ? (this.$refs.video_error_poster_webinar as HTMLElement).clientWidth *
        0.56
      : 0
  }
  public checkSize() {
    this.panelHeight = (this.$refs.curvideo as HTMLElement).clientHeight
  }
  public init() {
    EventBus.$emit("carouselSetupCompleted")
    this.panelHeight = (this.$refs.curvideo as HTMLElement).clientHeight
  }
}
